module.exports = __webpack_public_path__ + "static/media/getting-started-img.c9b1522a.svg";